<template>
  <ToastPortal>
    <ToastRoot
      v-for="(notification, index) in notifications"
      :key="notification.value.id ?? index"
      v-model:open="notification.value.open"
      class="alert mb-2 shadow-lg"
      :class="notification.value.type ? `alert-${notification.value.type}` : undefined"
    >
      <div class="flex flex-col">
        <ToastTitle class="font-bold">{{ notification.value.title }}</ToastTitle>
        <ToastDescription class="text-sm">{{ notification.value.message }}</ToastDescription>
      </div>
      <ToastAction
        v-for="action in notification.value.actions"
        :key="action.text"
        :alt-text="action.text"
        class="btn btn-sm"
        @click="action.onClick"
      >
        {{ action.text }}
      </ToastAction>
    </ToastRoot>
    <ToastViewport class="fixed right-0 bottom-0 z-50 flex w-96 max-w-full flex-col p-4" />
  </ToastPortal>
</template>

<script setup lang="ts">
import {
  ToastAction,
  ToastDescription,
  ToastPortal,
  ToastRoot,
  ToastTitle,
  ToastViewport,
} from 'reka-ui';
import { useNotifications } from '../stores/notificationStore';

const { notifications } = useNotifications();
</script>
